var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('circle',{attrs:{"cx":"28","cy":"28","r":"20"}}),_c('line',{attrs:{"x1":"56","y1":"56","x2":"42.14","y2":"42.14"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }